import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { List, ListItem } from "@mui/material";
//import { Button } from "components/common/Buttons/MainButton";
import { Box } from "@mui/system";
import Button from '@mui/material/Button';
import { sortByCreateDate } from "helpers/sort";
import { endPoints } from "const/endPoints";
import { fetchWithToken } from "helpers/fetch";
import Spinner from "components/common/Spinner";
import { useNavigate } from 'react-router-dom';

export const SectionAccordion = ({ section, courseTitle, isPay, currentId = "", slice = false, handleDrawerClose, fromDrawer = false }) => {
  const [lessonsAndQuizzes, setLessonsAndQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  const getLessonsAndQuizzes = async (section) => {
    const lessons = await fetchWithToken(
      `${endPoints.get_all_lessons_by_section}/${section.id}`
    );
    const bodyLessons = await lessons.json();
    const quizzes = await fetchWithToken(
      `${endPoints.get_all_quiz_by_section}/${section.id}`
    );
    const bodyQuizzes = await quizzes.json();
    if (lessons.status === 200 && quizzes.status === 200) {
      setLessonsAndQuizzes(sortByCreateDate(bodyLessons, bodyQuizzes));
      setLoading(false);
    } else {
      if (lessons.status === 200) {
        setLessonsAndQuizzes(bodyLessons);
        setLoading(false);
      } else {
        setLessonsAndQuizzes(bodyQuizzes);
        setLoading(false);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    getLessonsAndQuizzes(section);
  }, []);
  const navigate = useNavigate();

  const handleButtonClick = (to) => {
    console.log('handleButtonClick', to);
    if (fromDrawer) handleDrawerClose();
    navigate(to)
  }


  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "300px",
          width: "100%",
        }}
      >
        <Spinner />
      </Box>
    );
  }

  return (
    <Accordion
      key={section.id}
      defaultExpanded={currentId === section.id}
      sx={{
        border: "none",
        boxShadow: "none",
        margin: "0 0 24px 0",
        backgroundColor: "transparent",
        "&:before": {
          display: "none",
        },
        "& .MuiAccordion-root": {
          border: "none",
          boxShadow: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon 
            sx={{
              color: currentId === section.id ? "#5866ad" : "#666",
              fontSize: "28px",
              transition: "all 0.2s ease",
            }}
          />
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          backgroundColor: "transparent",
          padding: "8px 16px",
          borderRadius: "0",
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&.Mui-expanded": {
            backgroundColor: "transparent",
            minHeight: "48px",
          },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: "1.3rem",
            fontWeight: 700,
            color: currentId === section.id ? "#5866ad" : "#333",
            letterSpacing: "0.5px",
            textShadow: currentId === section.id ? "0 1px 2px rgba(88, 102, 173, 0.2)" : "none",
            transition: "all 0.2s ease",
            "@media (max-width: 768px)": {
              fontSize: "1.1rem",
            },
            "@media (max-width: 600px)": {
              fontSize: "1.05rem",
            },
          }}
        >
          {section.name}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: "16px 0 8px 0",
          "@media (max-width: 600px)": {
            padding: "12px 0 6px 0",
          },
        }}
      >
        <List
          sx={{
            padding: "0",
          }}
        >
          {lessonsAndQuizzes.length > 0 ? (
            lessonsAndQuizzes.map((lessonOrQuiz, j) => {
              // macOS style alternating cards instead of flat colors
              const isEven = j % 2 === 0;
              const type = lessonOrQuiz.status ? "quiz" : "clase";
              return (
                <ListItem
                  key={j}
                  onClick={isPay ? () => handleButtonClick(`/course/classroom/${courseTitle}/${type}/${lessonOrQuiz.id}`) : undefined}
                  component={isPay ? "button" : "div"}
                  sx={{
                    border: "none",
                    boxShadow: "none",
                    borderRadius: "16px",
                    background: isPay ? (
                      type === "quiz" 
                        ? "linear-gradient(135deg, rgba(55, 176, 207, 0.1) 0%, rgba(88, 102, 173, 0.15) 100%)"
                        : "linear-gradient(135deg, rgba(88, 102, 173, 0.1) 0%, rgba(55, 176, 207, 0.15) 100%)"
                    ) : (
                      isEven 
                        ? "linear-gradient(135deg, rgba(248, 249, 250, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%)"
                        : "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.9) 100%)"
                    ),
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    boxShadow: isEven 
                      ? "0 4px 16px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.02)"
                      : "0 2px 8px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(0, 0, 0, 0.02)",
                    margin: "12px 16px",
                    transition: "all 0.2s ease",
                    border: isPay 
                      ? `2px solid ${type === "quiz" ? "rgba(55, 176, 207, 0.3)" : "rgba(88, 102, 173, 0.3)"}`
                      : "1px solid rgba(88, 102, 173, 0.08)",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    cursor: isPay ? "pointer" : "default",
                    width: "100%",
                    textAlign: "left",
                    "&:hover": isPay ? {
                      transform: "translateY(-2px)",
                      boxShadow: type === "quiz" 
                        ? "0 8px 24px rgba(55, 176, 207, 0.2), 0 4px 8px rgba(88, 102, 173, 0.1)"
                        : "0 8px 24px rgba(88, 102, 173, 0.2), 0 4px 8px rgba(55, 176, 207, 0.1)",
                      borderColor: type === "quiz" ? "rgba(55, 176, 207, 0.5)" : "rgba(88, 102, 173, 0.5)",
                    } : {
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(88, 102, 173, 0.1)",
                      borderColor: "rgba(88, 102, 173, 0.15)",
                    },
                    "&:active": isPay ? {
                      transform: "translateY(0)",
                    } : {},
                    "@media (max-width: 768px)": {
                      padding: "16px 12px",
                      margin: "8px 8px",
                      borderRadius: "12px",
                    },
                    "@media (max-width: 600px)": {
                      padding: "14px 12px",
                      margin: "6px 6px",
                      borderRadius: "10px",
                    },
                    "@media (max-width: 480px)": {
                      padding: "12px 8px",
                      margin: "4px 4px",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <Box 
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "12px",
                        background: type === "quiz" 
                          ? "linear-gradient(135deg, #37b0cf 0%, #5866ad 100%)"
                          : "linear-gradient(135deg, #5866ad 0%, #37b0cf 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                        boxShadow: "0 4px 12px rgba(88, 102, 173, 0.3)",
                        flexShrink: 0,
                        "@media (max-width: 600px)": {
                          width: 40,
                          height: 40,
                          marginRight: "12px",
                        },
                        "@media (max-width: 480px)": {
                          width: 36,
                          height: 36,
                          marginRight: "10px",
                        },
                      }}
                    >
                      {type === "quiz" ? (
                        <Typography sx={{ color: "white", fontWeight: 700, fontSize: "14px" }}>
                          Q
                        </Typography>
                      ) : (
                        <Typography sx={{ color: "white", fontWeight: 700, fontSize: "14px" }}>
                          ▶
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontSize: "1.1rem",
                          color: isPay ? (type === "quiz" ? "#37b0cf" : "#5866ad") : "#333",
                          fontWeight: 600,
                          lineHeight: 1.4,
                          letterSpacing: "0.3px",
                          marginBottom: isPay ? "4px" : "0",
                          "@media (max-width: 768px)": {
                            fontSize: "0.95rem",
                          },
                          "@media (max-width: 600px)": {
                            fontSize: "0.9rem",
                            lineHeight: 1.3,
                          },
                          "@media (max-width: 480px)": {
                            fontSize: "0.85rem",
                          },
                        }}
                      >
                        {!slice ? lessonOrQuiz.name : `${(lessonOrQuiz.name).slice(0, 20)}${lessonOrQuiz.name.length > 20 ? '...' : ''}`}
                      </Typography>
                      {isPay && (
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            color: type === "quiz" ? "rgba(55, 176, 207, 0.8)" : "rgba(88, 102, 173, 0.8)",
                            fontWeight: 500,
                            "@media (max-width: 600px)": {
                              fontSize: "0.8rem",
                            },
                          }}
                        >
                          {type === "quiz" ? "Haz clic para entrar al quiz" : "Haz clic para entrar a la clase"}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </ListItem>
              );
            })
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100px",
              }}
            >
              <Typography
                sx={{
                  color: "#808080",
                  fontFamily: "Helvetica",
                  fontWeight: "500",
                }}
              >
                {currentId} , {section.id}
              </Typography>
            </Box>
          )}
        </List>
      </AccordionDetails>
    </Accordion >
  );
};
